import React,{useState, useContext,useEffect} from 'react';
import CartaContext from '../../context/cartaContext/cartaContext';
import AuthContext from '../../context/authContext/authContext';
import AdminContext from '../../context/adminContext/adminContext';
import AdminLayout from './AdminLayout';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import {
    useMediaQuery,
    Container,
    Button,
    Stepper,
    Typography,
    Step,
    StepLabel,
    StepContent,
    Card,
    AccordionSummary,
    Accordion,
    AccordionDetails,
    FormGroup,
    Checkbox,
    CardContent,
    CardActions,
    CircularProgress,
    Snackbar,
    TextField,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    DialogTitle,
    Backdrop,
    Paper,
    IconButton
} from '@material-ui/core';

//ALERTAS
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
//ESTILOS
const useStyles = makeStyles((theme) => ({
    cabecera:{
        padding : '2rem',
        [theme.breakpoints.up('md')]: {
            fontSize : "16px"
        }
    },
    borrarIngrediente: {
        display :'flex',
        justifyContent : 'space-between',
        alignContent : 'center',
        alignItems : 'center',
        "& p" : {
            alignItems : 'center'
        }
    },
    radio : {
        display : 'flex',
        flexDirection : 'column',
        textTransform : 'capitalize',
        padding : '4px 8px 8px',
        width : '100%',
        [theme.breakpoints.up('sm')] : {
            flexDirection : 'row',
            flexWrap : 'wrap'
        }
        
        
    },
    form : {
        textTransform : 'capitalize',
        
    },
    grupoRadio : {
        width : '100%',
        textTransform: 'capitalize',
        display : 'flex'
    },
    stepper :{
        padding : '10px',
        marginTop : '10px'
    },
    botonera : {
        padding : '5px',
        margin: '5px',
        '& button' : {
            margin : '.8rem'
        }
    },
    botones : {
        width: "100%",
        display : "flex",
        justifyContent: "center"
    },
    circular : {
        display: 'flex',
        '& > * + *': {
        marginLeft: theme.spacing(2),
            },
    },
    precio : {
        fontWeight : 'bold',
        color: "black"
    },
    card : {
        margin : '1rem',
        width: '95%'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
    ingredientes : {
        width : '100%',
        display : 'flex',
        height:'200px',
        flexGrow : 1,
        textTransform : 'capitalize',
        alignItems:'flex-start',
        paddingLeft : '1rem',
        [theme.breakpoints.down('sm')] : {
            flexDirection : 'column',
            height : '100%'
        }

    },
    listadoBebidas: {
        display : 'flex',
        marginBottom : '1rem',
        textTransform : 'capitalize',
        padding : '1rem'
    },
    bebida : {
        display : 'flex',
        alignItems : 'center',
        padding : '1rem'
    },
    bebida_input : {
        width : '15%',
        marginLeft : '1rem',
    },
    area : {
        marginTop : '1rem',
        '& textarea ':{
            resize: 'none',
            width : '100%'
          }
    },
    titulo : {
        textTransform : 'uppercase',
        textAlign : 'center'
    },
    descripcion : {
        marginLeft : '.5rem',
        textTransform : 'capitalize'
    },
    platos : {
        display : 'flex',
        width : '100%',
        flexDirection : 'column',
        [theme.breakpoints.up('sm')] : {
            flexDirection : 'column',
            flexWrap : 'wrap'
        }
        
    },
    plato : {
        width : '100%',
        [theme.breakpoints.up('sm')] : {
            width : '45%'
        }
        
    }

}));


function getSteps() {
    return ['Seleccione Menu', 'Seleccione ingrediente'];
  }
  
 
const AddSalon = (props) => {
    //PROPS
    const {pedido} = props.location.state
    //SI LA PANTALLA ES MAYOR A 600 PX MATCHES === TRUE
    const matches = useMediaQuery('(min-width:600px)');
    //STATE DEL CONTEXT MENU
    const cartaContext = useContext(CartaContext);
    const {
            bebidaSalon,
            ingredientes,
            platos,
            cargando,
            obtenerMenuStock,
    } = cartaContext;
   
    //STATE DEL CONTEXT AUTH
    const authContext = useContext(AuthContext);
    const {
        cliente,
        autenticado,
        mensaje,
        error,
        carrito,
        total_carrito,
        addCarrito,
        deleteCarrito,
        reiniciarErrorMensaje,
        getCarrito,
        deleteBebida,
        errorStepper,
   
        
            } = authContext; 
     //STATE DEL CONTEXT ADMIN
     const adminContext = useContext(AdminContext);
     const {addMenuDelivery} = adminContext;
    //STATE LOCALES
    const [formulario, setFormulario] = useState([
        {
            platos: null,
            ingredientes : [],
            bebidas: []
        }
    ]);
    const [especial, setespecial] = useState(false);
    const [referencia, setreferencia] = useState();
    const [mesa, setmesa] = useState();
    const [tipoPlato, settipoPlato] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [Open, setOpen] = useState(false);
    const [isloading, setisloading] = useState(false);
    const steps = getSteps();
    //FILTAR CATEGORIAS DE PLATOS
    const filtrar_categorias = [];
    //FILTRAR CATEGORIAS DE BEBIDAS
    const filtrar_bebidas = []
    //OBTENER CATEGORIAS DE PLATOS Y BEBIDAS
    if(!cargando && platos){
        platos.forEach(element => {
            filtrar_categorias.push(element.categoria);
            
        });
        var unique = filtrar_categorias.filter((v, i, a) => a.indexOf(v) === i); 
        
    }
    if(!cargando && bebidaSalon){
        bebidaSalon.forEach(element => {
            filtrar_bebidas.push(element.categoria);
            
        });
        var beb = filtrar_bebidas.filter((v, i, a) => a.indexOf(v) === i); 
        
    }
    //ESTILOS
    const classes = useStyles()
    //USEEFFECT
    useEffect(() => {
        obtenerMenuStock()
        
        if(!props.location.state ) {
            props.history.push('/admin/salon')
        }
        if(cliente){
            getCarrito(cliente)
            if(pedido){
                setmesa(pedido.mesa)
                setreferencia(pedido.referencia)
            }
        }
        
        
       // eslint-disable-next-line   
    }, [autenticado,mensaje, mesa]);  
     //PASOS DEL STTEPER
    function getStepContent(stepIndex) {
        switch (stepIndex) {
        case 0:
            return  <RadioGroup aria-label="gender" name="gender1" className={classes.grupoRadio}>
                                {unique ? unique.map(categoria => {
                                    return <div key = {categoria} className={classes.platos}>
                                    <Accordion  >
                                        <AccordionSummary 
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                        <Typography  >{categoria}</Typography>
                                            </AccordionSummary>
                                           
                                            <AccordionDetails className ={classes.radio} >
                                            {platos ? platos.map(plato => {
                                                if(plato.categoria === categoria){
                                                    return <FormControlLabel 
                                                                key={plato._id} 
                                                                value={plato._id}
                                                                name = {plato.nombre }
                                                                checked = {formulario[0].platos === plato._id ? true : false} 
                                                                control={<Radio />} 
                                                                label={`${plato.nombre}    $ ${plato.precio}`} 
                                                                onChange={platoChange}
                                                                labelPlacement = 'end'
                                                                className= {classes.plato}
                                                                />
                                                            
                                                    }
                                                return null
                                            })
                                            : <div>Cargando..</div>
                                            }
                                            </AccordionDetails>
                                            
                                        
                                       </Accordion>
                                       </div> 
                                }) 
                                :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
                               
                        </RadioGroup>
        case 1:
            return <Paper>{tipoPlato === "milanesa" || tipoPlato === "hamburguesa" ? <FormGroup className={classes.ingredientes}>
            {ingredientes ? ingredientes.map(ingrediente => {
              
            if(tipoPlato === "milanesa" && ingrediente.precio_milanesa ){
                
                return <FormControlLabel
                        key={ingrediente._id}
                        checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                        control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                        label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                            : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                        onChange={ingredienteChange}
                    />
                }
            if(tipoPlato === "hamburguesa" ){
                return <FormControlLabel
                key={ingrediente._id}
                checked = {formulario[0].ingredientes.includes(ingrediente._id)}
                control={<Checkbox   value={ingrediente._id} name={ingrediente.nombre} />}
                label={tipoPlato === "hamburguesa" ? `${ingrediente.nombre}  $ ${ingrediente.precio_hamburguesa}` 
                                    : `${ingrediente.nombre}  $ ${ingrediente.precio_milanesa}` }
                onChange={ingredienteChange}
            />
            }
            return null    
                })
            
            
            :<div className={classes.circular}><CircularProgress  color="secondary" /></div> 
            }

            </FormGroup>
            : <Typography color='error'>Al menu seleccionado no se le pueden colocar ingredientes.</Typography>
            }</Paper>
        default:
            return 'Error recargue la pagina';
    }
  }
//FUNCIONES DEL COMPONENTE

const platoChange = (e) => {
  platos.map(plato =>{
      if(plato._id === e.target.value){
        settipoPlato(plato.categoria)
      }
      return null 
})
  
    const newArray = [];
    const plato = e.target.value;
    newArray.push({platos : plato,
                 ingredientes : [],  
                 bebidas : []
                });
    setFormulario(newArray)
    if(e.target.value === "5fb807ca72e3cf2886f5d707" || e.target.value === "5fb807e472e3cf2886f5d708" ||  
        e.target.value === "5fb8083172e3cf2886f5d70b" || e.target.value === "5fb8084272e3cf2886f5d70c" ||
        e.target.value === "5fb8086a72e3cf2886f5d70d" || e.target.value === "5fb8088b72e3cf2886f5d70e" ||
        e.target.value === "5fc2c4deafc7b90017c6e14d" ){
            setespecial(true)
        }else{
            setespecial(false)
        }
};
const ingredienteChange = (e) => {
    const newArray = [...formulario]
    const ingrediente = newArray[0].ingredientes
    if (e.target.checked) {
        ingrediente.push(e.target.value);
    } else {
            const idx = ingrediente.indexOf(e.target.value);
        if(idx > -1){
            ingrediente.splice(idx, 1);
        }
        
    }
    
    newArray[0].ingredientes = ingrediente
    setFormulario(newArray)
};
const bebidaChange = (e) => {
  
    const newArray = [...formulario]
    const bebida = newArray[0].bebidas
    
    if(bebida.find(indx => indx === e.target.id)){
        bebida.splice(0);
        for (let index = 0; index < e.target.value; index++) {
            bebida.push(e.target.id)
        }
    }else{
        for (let index = 0; index < e.target.value; index++) {
            bebida.push(e.target.id)
        }
    }
    // if (e.target.checked) {
    //     bebida.push(e.target.value);
    // } else {
    //         const idx = bebida.indexOf(e.target.value);
    //     if(idx > -1){
    //         bebida.splice(idx, 1);
    //     }
        
    // }
    newArray[0].bebidas = bebida
     setFormulario(newArray)
};

const handleClose = () => {
    reiniciarErrorMensaje()
};
const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
};
const handleBack = () => {
    if(activeStep === 3){
        setActiveStep(0)
    }else {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
    
};
const eliminarMenu = async id => {
    setisloading(true)
    await deleteCarrito(id , cliente)
    if(carrito.length === 1){
        setActiveStep(0);
        setOpen(false);
        setFormulario([
            {
                platos: null,
                ingredientes : [],
                bebidas: []
            }
            ]);
    }
    setisloading(false)
    
};
const agregarOtroMenu = async () => {
    
    setisloading(true)
    await addCarrito(formulario[0],cliente)
    setFormulario([
        {
            platos: null,
            ingredientes : [],
            bebidas: []
        }
        ]);
    settipoPlato();
    setActiveStep(0)
    setespecial(false)
    setisloading(false)
    
};
//DUPLICAR MENU
const duplicateMenu = async menu => {
    let duplicar = {
        platos : null,
        ingredientes : [],
        bebidas : [],
        copia : menu._id
    }
    if(menu.platos){
        duplicar.platos = menu.platos._id;
    }
    if(menu.ingredientes.length > 0){
        menu.ingredientes.forEach(ingrediente => {
            duplicar.ingredientes.push(ingrediente._id)
        });
        
    }
    if(menu.bebidas.length > 0){
        menu.bebidas.forEach(bebida => {
            duplicar.bebidas.push(bebida._id)
        });
    }
    await addCarrito(duplicar , cliente)
}
//ABRIR CONFIRMACION DE PEDIDO 
const confirmarPedido = async e => {
    if( formulario[0].platos == null && formulario[0].bebidas.length === 0 && carrito.length === 0 ){
        
        errorStepper()
        return
    } 
        setisloading(true);
            //SEPARAR BEBIDAS DEL CARRITO
            const bebidas = {
                platos : null,
                ingredientes : [],
                bebidas : formulario[0].bebidas
                }
            let menu = formulario[0];
            menu.bebidas = [];
            if(menu.platos){
                await addCarrito(menu,cliente)
            }    
            if(bebidas.bebidas.length > 0){
                await addCarrito(bebidas, cliente)
            }
          
            
            settipoPlato();
            setActiveStep(0)
            setisloading(false)
            setOpen(true)
        
}
    
//FINALIZAR PEDIDO
const agregarMenu = async (pedido,menu) => {
    setisloading(true)
    setOpen(false)
    await addMenuDelivery(pedido,menu)
  
    setTimeout(
        function(){
            props.history.push('/admin/salon')
            setisloading(false)
        }
       ,
        2000
    )
    
};
//CANCELAR ORDEN
const cancelOrder = async e => {
    setisloading(true)
    setFormulario([
        {
            platos: null,
            ingredientes : [],
            bebidas: []
        }
        ]);
    setOpen(false)
    setActiveStep(0)
    setisloading(false)
};
//ELIMINAR BEBIDA
const eliminarBebida = async id => {
    setisloading(true)
    deleteBebida(cliente , id)
    setisloading(false)
}

    return (
        <AdminLayout>
            <Backdrop className={classes.backdrop} open={isloading} onClick={handleClose}>
                <CircularProgress color="inherit" />
            </Backdrop>
            
             
              <Snackbar open={mensaje ? true : false} autoHideDuration={4000} 
                        onClose={handleClose}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                <Alert onClose={handleClose} severity="success">
                    {mensaje}
                </Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} 
                        onClose={handleClose}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                    <Alert onClose={handleClose} severity="error">
                        {mensaje}
                    </Alert>
                </Snackbar>
            {matches ?
                <Container maxWidth="md">
                    <div >
            <Typography variant="h4" gutterBottom={true}>Mesa : {mesa ? mesa : null}</Typography>
                      
                   
                        <Typography variant="h4" align="center" gutterBottom={true}>Para Comer</Typography>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <div>
                            {activeStep === steps.length ? (
                                <div>hola</div>
                            ) : (
                                    <div>
                                        {getStepContent(activeStep)}
                                        
                                        <div className={classes.botonera}>
                                            <Button
                                                disabled={activeStep === 0}
                                                onClick={handleBack}
                                                
                                            >
                                                Atras
                                            </Button>
                                            {
                                                (tipoPlato === "hamburguesa" && activeStep === 0 && !especial) || (tipoPlato === "milanesa" && activeStep === 0 && !especial) ? 
                                                <Button variant="contained" color="primary" onClick={handleNext}>
                                                   Siguiente
                                                </Button>
                                                : null
                                            }
                                          
                                            {
                                               ( tipoPlato !== "hamburguesa" && tipoPlato !== "milanesa" && tipoPlato !== undefined ) || (activeStep === 1 ) || (tipoPlato !== undefined && especial)?
                                                <Button variant="contained" color="primary" onClick={() => agregarOtroMenu()}>
                                                    Agregar otro menu
                                                </Button>
                                           
                                            :   null
                                            }
                                            
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                    <div>
                    <Typography variant="h4" align="center" gutterBottom={true}>Para tomar</Typography>
                    <Paper>
                    <FormGroup className={classes.listadoBebidas}>
                            {beb ? beb.map(categoria => {
                                    return  <Accordion key = {categoria} className = {classes.platos}>
                                        <AccordionSummary 
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                        <Typography  variant="h6">{categoria === "sin_alcohol" ? "Sin Alcohol" : categoria}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className ={classes.radio} >
                                            {bebidaSalon ? bebidaSalon.map(bebida => {
                                                if(bebida.categoria === categoria){
                                                    return <div key={bebida._id} className={classes.bebida} >
                                                        <Typography style={{width : '270px'}}>{`${bebida.nombre} $ ${bebida.precio} :`}</Typography>
                                                            <div className={classes.bebida_input}>
                                                                <TextField 
                                                                    id={bebida._id}
                                                                    type="number"
                                                                     InputLabelProps={{
                                                                            shrink: true,
                                                                    }}  
                                                                    onChange={bebidaChange}
                                                                    name={bebida.nombre } 
                                                                    inputProps={
                                                                        {min : "0"}
                                                                    }
                                                                />
                                                            </div>
                                                            </div>
                                                }else{
                                                    return null
                                                }
                            
                                            })
                                            : <CircularProgress className={classes.circular} color="secondary" />
                                            }
                                            
                                            
                                            </AccordionDetails>
                                       </Accordion>
                                     
                                }) 
                                :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
                
                          
                        </FormGroup>  
                    </Paper>
                    </div>
                    <div>
                        <Button variant="contained" color="primary" fullWidth onClick={()=>confirmarPedido()}>FINALIZAR ORDEN</Button>
                    </div>

                </Container>
                : <Container maxWidth="sm">
                
                        <Typography variant="h4" gutterBottom={true}>Mesa : {mesa ? mesa : null}</Typography>
                    
                        <Typography variant="h4" align="center" gutterBottom={true}>Para Comer</Typography>
                     <Stepper activeStep={activeStep} orientation="vertical" className={classes.stepper}>
                        {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                    <StepContent>
                                        <FormControl component="fieldset" className={classes.form} >
                                            {getStepContent(index)}
                                        </FormControl >
                                        <div className={classes.botonera}>
                                            <Button
                                                disabled={activeStep === 0}
                                                onClick={handleBack}
                                                
                                            >
                                                Atras
                                            </Button>
                                            {
                                                ((tipoPlato === "hamburguesa") && (activeStep === 0) && (!especial)) || ((tipoPlato === "milanesa") && (activeStep === 0)  && (!especial) )? 
                                                <Button variant="contained" color="primary" onClick={handleNext}>
                                                   Siguiente
                                                </Button>
                                                : null
                                            }
                                          
                                            {
                                               (( tipoPlato !== "hamburguesa") && (tipoPlato !== "milanesa") && (tipoPlato !== undefined) ) || (activeStep === 1 ) || ((tipoPlato !== undefined) && (especial)) ?
                                                <Button variant="contained" color="primary" onClick={() => agregarOtroMenu()}>
                                                    Duplicar
                                                </Button>
                                           
                                            :   null
                                            }
                                            
                                        </div>
                                    </StepContent>
                                </Step>
                        ))}
            </Stepper>
            <div>
                    <Typography variant="h4" align="center" gutterBottom={true}>Para tomar</Typography>
                    <Paper>
                    <FormGroup className={classes.listadoBebidas}>
                            {beb ? beb.map(categoria => {
                                    return  <Accordion key = {categoria} className = {classes.platos}>
                                        <AccordionSummary 
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                        <Typography  variant="h6">{categoria === "sin_alcohol" ? "Sin Alcohol" : categoria}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className ={classes.radio} >
                                            {bebidaSalon ? bebidaSalon.map(bebida => {
                                                if(bebida.categoria === categoria){
                                                    return <div key={bebida._id} className={classes.bebida} >
                                                        <Typography style={{width : '270px'}}>{`${bebida.nombre} $ ${bebida.precio} :`}</Typography>
                                                            <div className={classes.bebida_input}>
                                                                <TextField 
                                                                    id={bebida._id}
                                                                    type="number"
                                                                     InputLabelProps={{
                                                                            shrink: true,
                                                                    }}  
                                                                    onChange={bebidaChange}
                                                                    name={bebida.nombre } 
                                                                    inputProps={
                                                                        {min : "0"}
                                                                    }
                                                                />
                                                            </div>
                                                            </div>
                                                }else{
                                                    return null
                                                }
                            
                                            })
                                            : <CircularProgress className={classes.circular} color="secondary" />
                                            }
                                            
                                            
                                            </AccordionDetails>
                                       </Accordion>
                                     
                                }) 
                                :<div className={classes.circular}><CircularProgress  color="secondary" /></div>}
                
                          
                        </FormGroup>  
                    </Paper>
          
                    </div>
                    <div>
                        <Button variant="contained" color="primary" fullWidth onClick={()=>confirmarPedido()}>FINALIZAR ORDEN</Button>
                    </div>
            </Container>}
            <Dialog
                open={Open}
                
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirmar el pedido?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.cabecera}>
                    <Typography variant="body2" color="textprimary">Mesa:</Typography>
                    <Typography display="block" color="secondary" className={classes.descripcion} >{mesa}</Typography>
                    <Typography variant="body2" color="textprimary">Referencia:</Typography>
                    <Typography display="block" color="secondary" className={classes.descripcion} >{referencia}</Typography>
                        {carrito ? carrito.map(menu =>{
                            return  <Card  key= {Math.random()} className = {classes.card}>
                                <CardContent>
                                  <Typography variant="h5" component="h2" className={classes.titulo}>
                                        {menu.platos ? menu.platos.nombre : "--"}
                                </Typography>
                                <Typography  color="textSecondary">
                                    {menu.ingredientes.length > 0 ? "Ingredientes:" : null}
                                </Typography>
                                {menu.ingredientes.map(ingre =>{
                                    return <Typography key ={Math.random()}variant="body2" component="p"className={classes.descripcion}>
                                            {ingre.nombre ? ingre.nombre : " --" }
                                            </Typography>
                                })}
                             
                                <Typography color="textSecondary">
                                   {menu.bebidas.length > 0 ? "Bebidas:" : null}
                                </Typography>
                                {menu.bebidas.map(bebida =>{
                                                    return <div key = {Math.random()} className={classes.borrarIngrediente}>
                                                                <Typography  variant="body2" component="p" className={classes.descripcion}>
                                                                     {bebida.nombre}
                                                                </Typography>
                                                                <IconButton aria-label="delete" onClick={() => eliminarBebida(bebida._id)} >
                                                                        <DeleteIcon color="error" />
                                                                </IconButton>
                                                           </div>
                                                })}
                                <Typography align="right">
                                    Subtotal : $ {
                                       menu.subtotal
                                        
                                    }
                                </Typography>
                            </CardContent>
                        <CardActions>
                                <Button size="small" variant="contained" color="secondary" onClick= {e=> eliminarMenu(menu._id)}> Eliminar</Button>
                                <Button size="small" variant="contained" onClick= {e=> duplicateMenu(menu)}> Duplicar</Button>
                    </CardActions>
                  </Card>
                
                     })
                    : null}
             
                         {carrito.length !== 0 ? <Typography align="right" className= {classes.precio} variant="body1">PRECIO FINAL : ${total_carrito}</Typography> : <CircularProgress className={classes.circular} color="secondary" />}
                    </DialogContentText>
                </DialogContent>
            <DialogActions>
        <div className={classes.botones}>
        <Button onClick={cancelOrder} color="primary">
            Olvide algo
          </Button>
          <Button onClick={() =>agregarMenu(props.location.state.pedido , carrito)} color="primary" variant="contained" autoFocus>
            Confirmar pedido
          </Button>
        </div>
          
        </DialogActions>
      </Dialog>
        </AdminLayout>
    );
}

export default AddSalon;